import style from './container.module.scss';

interface Props {
    children: React.ReactNode;
    fluid?: boolean;
    wide?: boolean;
    middle?: boolean;
    narrow?: boolean;
    classes?: string[];
}


export default function Container({ children, fluid, wide, middle, narrow, classes = [] }: Props) {

    return (
        <div className={`
            ${style.container}
            ${fluid ? style.containerFluid : ''}
            ${wide ? style.containerWide : ''}
            ${middle ? style.containerMiddle : ''}
            ${narrow ? style.containerNarrow : ''}
            ${classes.join(' ')}
            `.replace(/\s+/g, ' ').trim()}
        >
            {children}
        </div>
    )
}